import React from "react";
import { Routes, Route } from "react-router-dom";
import AppShell from "@/components/AppShell";
import Overview from "@/components/Overview";
import Deadlines from "@/components/Deadlines";
import Documents from "@/components/Documents";
import Invoices from "@/components/Invoices";
import Assistant from "@/components/Assistant";

const Portal = () => (
  <AppShell portalMode>
    <Routes>
      <Route index element={<Overview portalMode />} />
      <Route path="deadlines" element={<Deadlines readOnly />} />
      <Route path="documents" element={<Documents readOnly />} />
      <Route path="invoices" element={<Invoices readOnly />} />
      <Route path="assistant" element={<Assistant />} />
    </Routes>
  </AppShell>
);

export default Portal;
